import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { useAppConfig } from '@state';
import { ErrorPage } from '@vindr/ui';

const NotFound = ({
  message = 'Sorry, this page does not exist.',
  showGoBackButton = false,
}) => {
  const [appConfig] = useAppConfig();
  const { showStudyList } = appConfig;

  return (
    <ErrorPage>
      <h4>{message}</h4>
      {showGoBackButton && showStudyList && (
        <h5>
          <Link to={window.PUBLIC_URL}>Go back to the Study List</Link>
        </h5>
      )}
    </ErrorPage>
  );
};

NotFound.propTypes = {
  message: PropTypes.string,
  showGoBackButton: PropTypes.bool,
};

export default NotFound;
